import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

/** The company feature roots on queryKeys.companies (companies list + CRUD invalidation).
 *  Read hooks for individual records use their own existing keys:
 *  companyDetails for getCompanyDetails, organization for getMyOrganization/showOrganization.
 *  INTERNAL — consumers use the exported hooks. */
export const companyApi = createFeatureApi(queryKeys.companies);
